module.exports = __webpack_public_path__ + "files/a62aa31272862eb267f3fa99cd1b70a3.png";